@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;
@use '../../design-tokens/breakpoints/breakpoints' as *;
@use '../custom-scroll/custom-scroll' as *;

@layer design-system {
  .backdrop {
    position: fixed;
    inset: 0;
    background-color: var(--background-backdrop);
    backdrop-filter: blur(1px);
    opacity: 0;
    transition: all 100ms cubic-bezier(0.4, 0, 0.2, 1);
    transition-delay: 200ms;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .backdropActive {
    transition-duration: 250ms;
    transition-delay: 0ms;
    opacity: 1;
  }

  .container {
    position: fixed;
    inset: 0;
    z-index: var(--z-index-modal);
  }

  .modalContainer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid var(--border-soft);
    @include border-radius-r2;
    background: var(--background-soft);
    padding-bottom: 24px;
    max-height: calc(100vh - 48px);
    overflow-y: auto;
    @include custom-scroll-minimal;

    @include respond-to('sm') {
      width: auto;
    }
  }

  .modalContainerFill {
    @include respond-to('sm') {
      width: 90%;
    }
  }

  .header {
    display: flex;
    align-items: flex-start;
    padding: 6px 6px 18px 12px;

    @include respond-to('sm') {
      padding: 6px 6px 18px 20px;
    }

    & + * {
      padding: 0 12px;

      @include respond-to('sm') {
        padding: 0 20px;
      }
    }
  }

  .textContainer {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 10px 0 18px;

    @include respond-to('sm') {
      margin: 18px 0;
    }
  }

  .title {
    @include typography-v2-title-lg;
  }

  .description {
    @include typography-v2-body-sm;
    color: var(--text-soft);
  }

  .closeButton {
    margin-left: auto;
    z-index: 1;
  }

  .buttonsContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 36px 12px 0;
    gap: 8px;

    @include respond-to('sm') {
      margin: 36px 20px 0;
    }

    @include respond-to('mobile') {
      flex-direction: column;
      align-items: flex-end;
    }
  }

  .buttonsContainerWithLeftAction {
    justify-content: space-between;
  }

  .imageContainer {
    margin-bottom: 12px;
  }

  .leftActionsContainer {
    display: flex;
    gap: 8px;
  }

  .rightActionsContainer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
}
